<template lang="html">
  <div class="login-container">
    <router-view />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";
</style>



// WEBPACK FOOTER //
// src/pages/User.vue